<template>
  <div class="diy-attribute">
    <div>
      <div class="title">所在动态群组</div>
      <div
        class="content"
        v-if="dynamicGroupList.length > 0"
      >
        <span
          class="content-dynamic-span"
          v-for="(item, index) in dynamicGroupList"
          :key="index"
        >
          {{ item.value }}
        </span>
      </div>
      <div
        class="content"
        v-else
        style="border:none;padding:0px 10px;"
      >
        <span
          class="content-dynamic-span"
          style="background-color:#D6D6D6"
        >暂无动态群组</span>
      </div>
    </div>
    <div>
      <div class="title">所在静态群组</div>
      <div
        class="content"
        v-if="staticGroupList.length > 0"
      >
        <el-tag
          class="content-static-span"
          v-for="item in staticGroupList"
          :key="item.id"
          closable
          @close="handleDeleteGroup(item.id)"
        >
          {{item.value}}
        </el-tag>
      </div>
      <div
        class="content"
        v-else
        style="border:none;padding:0px 10px;"
      >
        <span
          class="content-dynamic-span"
          style="background-color:#D6D6D6"
        >暂无静态群组</span>
      </div>
    </div>
    <div>
      <div class="title">标签</div>
      <div
        class="content"
        v-if="tags.length > 0"
      >
        <el-tag
          class="content-tags-span"
          v-for="item in tags"
          :key="item.id"
          closable
          @close="handleDeleteTag(item.id)"
        >
          {{item.value}}
        </el-tag>
      </div>
      <div
        class="content"
        v-else
        style="border:none;padding:0px 10px;"
      >
        <span
          class="content-dynamic-span"
          style="background-color:#D6D6D6"
        >暂无标签</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'groupTagsTemplate',
  props: ['dynamicGroupList', 'staticGroupList', 'tags'],
  model: {
    prop: 'value',
    event: 'change'
  },

  watch: {
    value: function (val) {
      this.curValue = val
    }
  },
  methods: {
    //删除静态群组 
    handleDeleteGroup (id) {
      this.$emit('handleDeleteGroup', id)
    },
    //删除静态标签 
    handleDeleteTag (id) {
      this.$emit('handleDeleteTag', id)
    },
  },
}
</script>

<style scoped>
.diy-attribute {
  text-align: left;
}
.title {
  height: 20px;
  line-height: 20px;
  color: #333;
  font-weight: bold;
  font-size: 14px;
  text-align: left;
  margin-left: 18px;
  margin-top: 27px;
}
.content {
  height: auto;
  line-height: 20px;
  color: #333;
  font-size: 12px;
  text-align: left;
  margin-left: 10px;
  margin-right: 10px;
  margin-top: 8px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  border: 1px solid #dedede;
  padding: 10px;
  border-radius: 5px;
}
.content-dynamic-span {
  background-color: #5ec5e0;
  color: #ffffff;
  padding: 5px;
  border-radius: 5px;
  margin-top: 5px;
  margin-right: 5px;
}
.content-static-span {
  background-color: #5ee0a2;
  color: #ffffff;
  border-radius: 5px;
  margin-top: 5px;
  margin-right: 5px;
}
.content-tags-span {
  background-color: #a7c7eb;
  margin-left: 0px;
  color: #ffffff;
  border-radius: 5px;
  margin-top: 5px;
  margin-right: 5px;
}
</style>
